import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap'

import type { ReactNode } from 'react'

type Props = {
  open: boolean
  content: ReactNode
  children: ReactNode
  direction?: 'up' | 'down' | 'start' | 'end'
  containerRef?: HTMLDivElement | HTMLElement | null
  isContainer?: boolean
  dropdownClassName?: string
  setOpen: () => void
}

export const DropdownList = ({
  open = false,
  content,
  children,
  direction = 'down',
  containerRef,
  isContainer,
  dropdownClassName,
  setOpen,
}: Props) => {
  return (
    <Dropdown isOpen={open} toggle={setOpen} direction={direction}>
      <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={open}>
        {content}
      </DropdownToggle>
      <DropdownMenu container={isContainer ? containerRef || document.body : undefined} className={dropdownClassName}>
        {children}
      </DropdownMenu>
    </Dropdown>
  )
}
export default DropdownList
